import { createActionsHook } from 'react-sweet-state';

import {
  createDataHook,
  createLoadingHook,
  createRestActions,
  createRestStore,
} from '@intelliarts/ia-react-template';

import { createMutationFailedCheck } from '../../../utils/restMutation';
import { RiskStatusEntity } from '../../Risks/models/Risk';

const actionConfig = { resourcePath: '/risks/statuses' };

export const riskStatusesActions = createRestActions<RiskStatusEntity>(actionConfig);

export const RiskStatusesStore = createRestStore<RiskStatusEntity>({
  name: 'risk-statuses-store',
  actions: riskStatusesActions,
  actionConfig,
  containerDisplayName: 'risk-statuses-container',
  onInitAction: null,
});

export const useRiskStatusesData = createDataHook(RiskStatusesStore);
export const useRiskStatusesIsLoading = createLoadingHook(RiskStatusesStore);
export const useRiskStatusesActions = createActionsHook(RiskStatusesStore);
export const didRiskStatusesMutationFail = createMutationFailedCheck(actionConfig.resourcePath);
